import { z } from "zod";

export const InvoiceSchema = z.object({
  clientId: z.string().cuid(),
  amount: z.number().min(0),
  vatRate: z.number().default(20),
  vatExempt: z.boolean().default(false),
  dueAt: z.coerce.date(),
  introTitle: z.string().max(200).optional().nullable(),
  introText: z.string().max(4000).optional().nullable(),
  description: z.string().max(500).optional().nullable(),
  /** Lie la facture à un rendez-vous terminé (même client). Incompatible avec `documentType: QUOTE`. */
  appointmentId: z.string().cuid().optional(),
  /** Facture ou devis (défaut : facture). */
  documentType: z.enum(["INVOICE", "QUOTE"]).optional().default("INVOICE"),
  /** Adresse de livraison / lieu de réalisation (mention obligatoire e-facture). */
  deliveryAddress: z.string().max(500).optional().nullable(),
  /** Remise affichée sur le PDF (optionnel). */
  discountPercent: z.number().int().min(1).max(100).optional().nullable(),
  discountSource: z.enum(["code", "campaign"]).optional().nullable(),
  discountLabel: z.string().max(200).optional().nullable(),
  amountHtBeforeDiscount: z.number().min(0).optional().nullable(),
});

export type InvoiceDto = z.infer<typeof InvoiceSchema>;
